import { Controller } from '@hotwired/stimulus';

// novalidate なフォームに Bootstrap の検証表示を付ける (#3119)。
// 送信時に checkValidity() で止め、was-validated を付けて
// .invalid-feedback を表示させる。
export default class extends Controller {
  validate(event) {
    if (!this.element.checkValidity()) {
      event.preventDefault();
      event.stopPropagation();
    }
    this.element.classList.add('was-validated');
  }
}
